var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/*
 * This file is part of the nivo project.
 *
 * Copyright 2016-present, Raphaël Benitte.
 *
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { getHoveredArc, getRelativeCursor, getLabelGenerator, Container } from '@nivo/core';
import { getInheritedColorGenerator } from '@nivo/colors';
import { renderLegendToCanvas } from '@nivo/legends';
import { arcPropType } from './props';
import { drawSliceLabels, drawRadialLabels } from './canvas';
import PieTooltip from './PieTooltip';

var PieCanvasRenderer = function (_Component) {
    _inherits(PieCanvasRenderer, _Component);

    function PieCanvasRenderer() {
        var _temp, _this, _ret;

        _classCallCheck(this, PieCanvasRenderer);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.getArcFromMouse = function (event) {
            var _getRelativeCursor = getRelativeCursor(_this.surface, event),
                x = _getRelativeCursor[0],
                y = _getRelativeCursor[1];

            var _this$props = _this.props,
                centerX = _this$props.centerX,
                centerY = _this$props.centerY,
                margin = _this$props.margin,
                radius = _this$props.radius,
                innerRadius = _this$props.innerRadius,
                arcs = _this$props.arcs;


            return getHoveredArc(margin.left + centerX, margin.top + centerY, radius, innerRadius, arcs, x, y);
        }, _this.handleMouseHover = function (showTooltip, hideTooltip) {
            return function (event) {
                if (_this.props.isInteractive !== true) return;

                var arc = _this.getArcFromMouse(event);
                if (arc) {
                    showTooltip(React.createElement(PieTooltip, { data: arc.data, color: arc.color, theme: _this.props.theme }), event);
                } else {
                    hideTooltip();
                }
            };
        }, _this.handleMouseLeave = function (hideTooltip) {
            return function () {
                if (_this.props.isInteractive !== true) return;

                hideTooltip();
            };
        }, _this.handleClick = function (event) {
            var arc = _this.getArcFromMouse(event);
            if (arc) _this.props.onClick(arc.data, event);
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    PieCanvasRenderer.prototype.componentDidMount = function componentDidMount() {
        this.ctx = this.surface.getContext('2d');
        this.draw(this.props);
    };

    PieCanvasRenderer.prototype.shouldComponentUpdate = function shouldComponentUpdate(props) {
        // only update if the DOM needs to be updated
        if (this.props.outerWidth !== props.outerWidth || this.props.outerHeight !== props.outerHeight || this.props.isInteractive !== props.isInteractive || this.props.theme !== props.theme) {
            return true;
        }

        this.draw(props);
        return false;
    };

    PieCanvasRenderer.prototype.componentDidUpdate = function componentDidUpdate() {
        this.ctx = this.surface.getContext('2d');
        this.draw(this.props);
    };

    PieCanvasRenderer.prototype.draw = function draw(props) {
        var _this2 = this;

        var arcs = props.arcs,
            arcGenerator = props.arcGenerator,
            width = props.width,
            height = props.height,
            centerX = props.centerX,
            centerY = props.centerY,
            radius = props.radius,
            outerWidth = props.outerWidth,
            outerHeight = props.outerHeight,
            pixelRatio = props.pixelRatio,
            margin = props.margin,
            borderWidth = props.borderWidth,
            borderColor = props.borderColor,
            enableSlicesLabels = props.enableSlicesLabels,
            enableRadialLabels = props.enableRadialLabels,
            legends = props.legends,
            theme = props.theme;


        this.surface.width = outerWidth * pixelRatio;
        this.surface.height = outerHeight * pixelRatio;

        this.ctx.scale(pixelRatio, pixelRatio);
        this.ctx.fillStyle = theme.background;
        this.ctx.fillRect(0, 0, outerWidth, outerHeight);
        this.ctx.save();
        this.ctx.translate(margin.left, margin.top);

        arcGenerator.context(this.ctx);

        this.ctx.save();
        this.ctx.translate(centerX, centerY);

        var getBorderColor = getInheritedColorGenerator(borderColor, theme);

        arcs.forEach(function (arc) {
            _this2.ctx.beginPath();
            _this2.ctx.fillStyle = arc.color;
            _this2.ctx.strokeStyle = getBorderColor(_extends({}, arc.data, { color: arc.color }));
            _this2.ctx.lineWidth = borderWidth;
            arcGenerator(arc);
            _this2.ctx.fill();
            if (borderWidth > 0) _this2.ctx.stroke();
        });

        if (enableSlicesLabels === true) {
            var sliceLabel = props.sliceLabel,
                slicesLabelsSkipAngle = props.slicesLabelsSkipAngle,
                slicesLabelsTextColor = props.slicesLabelsTextColor;


            drawSliceLabels(this.ctx, arcs, {
                arcGenerator: arcGenerator,
                skipAngle: slicesLabelsSkipAngle,
                getLabel: getLabelGenerator(sliceLabel),
                getTextColor: getInheritedColorGenerator(slicesLabelsTextColor, theme),
                theme: theme
            });
        }

        if (enableRadialLabels === true) {
            var radialLabel = props.radialLabel,
                radialLabelsSkipAngle = props.radialLabelsSkipAngle,
                radialLabelsLinkOffset = props.radialLabelsLinkOffset,
                radialLabelsLinkStrokeWidth = props.radialLabelsLinkStrokeWidth,
                radialLabelsLinkDiagonalLength = props.radialLabelsLinkDiagonalLength,
                radialLabelsLinkHorizontalLength = props.radialLabelsLinkHorizontalLength,
                radialLabelsTextXOffset = props.radialLabelsTextXOffset,
                radialLabelsTextColor = props.radialLabelsTextColor,
                radialLabelsLinkColor = props.radialLabelsLinkColor;


            drawRadialLabels(this.ctx, arcs, {
                radius: radius,
                getLabel: getLabelGenerator(radialLabel),
                skipAngle: radialLabelsSkipAngle,
                linkOffset: radialLabelsLinkOffset,
                linkDiagonalLength: radialLabelsLinkDiagonalLength,
                linkHorizontalLength: radialLabelsLinkHorizontalLength,
                linkStrokeWidth: radialLabelsLinkStrokeWidth,
                textXOffset: radialLabelsTextXOffset,
                getTextColor: getInheritedColorGenerator(radialLabelsTextColor, theme),
                getLinkColor: getInheritedColorGenerator(radialLabelsLinkColor, theme),
                theme: theme
            });
        }

        this.ctx.restore();

        legends.forEach(function (legend) {
            renderLegendToCanvas(_this2.ctx, _extends({}, legend, {
                data: arcs.map(function (arc) {
                    return {
                        id: arc.data.id,
                        label: arc.data.id,
                        color: arc.color
                    };
                }),
                containerWidth: width,
                containerHeight: height,
                theme: theme
            }));
        });
    };

    PieCanvasRenderer.prototype.render = function render() {
        var _this3 = this;

        var _props = this.props,
            outerWidth = _props.outerWidth,
            outerHeight = _props.outerHeight,
            pixelRatio = _props.pixelRatio,
            isInteractive = _props.isInteractive,
            theme = _props.theme;


        return React.createElement(
            Container,
            { isInteractive: isInteractive, theme: theme, animate: false },
            function (_ref) {
                var showTooltip = _ref.showTooltip,
                    hideTooltip = _ref.hideTooltip;
                return React.createElement('canvas', {
                    ref: function ref(surface) {
                        _this3.surface = surface;
                    },
                    width: outerWidth * pixelRatio,
                    height: outerHeight * pixelRatio,
                    style: {
                        width: outerWidth,
                        height: outerHeight
                    },
                    onMouseEnter: _this3.handleMouseHover(showTooltip, hideTooltip),
                    onMouseMove: _this3.handleMouseHover(showTooltip, hideTooltip),
                    onMouseLeave: _this3.handleMouseLeave(hideTooltip),
                    onClick: _this3.handleClick
                });
            }
        );
    };

    return PieCanvasRenderer;
}(Component);

PieCanvasRenderer.propTypes = process.env.NODE_ENV !== "production" ? {
    arcs: PropTypes.arrayOf(arcPropType).isRequired,
    arcGenerator: PropTypes.func.isRequired,

    // resolution
    pixelRatio: PropTypes.number.isRequired,

    // dimensions/layout
    outerWidth: PropTypes.number.isRequired,
    outerHeight: PropTypes.number.isRequired,
    centerX: PropTypes.number.isRequired,
    centerY: PropTypes.number.isRequired,
    margin: PropTypes.object.isRequired,
    radius: PropTypes.number.isRequired,
    innerRadius: PropTypes.number.isRequired,

    // interactivity
    isInteractive: PropTypes.bool.isRequired,
    onClick: PropTypes.func.isRequired,

    // theming
    theme: PropTypes.object.isRequired
} : {};


export default PieCanvasRenderer;